<template>
    <div>
        <transition name="fade">
            <div
                v-if="isVisibleSideBarGenericModal"
                class="modal-generic-backdrop"
                @click.self="closeModal"
            ></div>
        </transition>
        <div
            class="modal modal-side modal-right modal-command primary fade modal-generic-root"
            aria-hidden="true"
            :class="{ show: isVisibleSideBarGenericModal === true }"
            role="dialog"
            aria-modal="true"
        >
            <div class="modal-dialog modal-dialog-scrollable modal-generic-dialog">
                <div class="modal-content modal-generic">
                    <header class="modal-generic-head">
                        <div class="modal-generic-toolbar">
                            <button
                                type="button"
                                class="modal-generic-icon-btn"
                                aria-label="Fechar painel"
                                data-bs-dismiss="modal"
                                @click="closeModal"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 25 24" fill="none" aria-hidden="true">
                                    <path
                                        d="M12.5 19L5.5 12M5.5 12L12.5 5M5.5 12H19.5"
                                        stroke="currentColor"
                                        stroke-width="2"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    />
                                </svg>
                            </button>
                            <span class="modal-generic-toolbar-title">Parâmetros do agente</span>
                            <button
                                type="button"
                                class="modal-generic-icon-btn modal-generic-icon-btn--close"
                                aria-label="Fechar"
                                data-bs-dismiss="modal"
                                @click="closeModal"
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                                    <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M5.72 4.28a1 1 0 0 0-1.43 1.42L10.91 12l-6.6 6.3a1 1 0 0 0 1.38 1.38L12.35 13.37l6.43 6.13a1 1 0 0 0 1.43-1.42L13.8 12l6.4-6.09a1 1 0 1 0-1.43-1.42l-6.43 6.13-6.63-6.34Z"
                                        fill="currentColor"
                                    />
                                </svg>
                            </button>
                        </div>
                        <div class="modal-generic-hero">
                            <h2 class="modal-generic-title">{{ currentCrew?.name || 'Agente' }}</h2>
                            <p v-if="crewDescription" class="modal-generic-desc">{{ crewDescription }}</p>
                        </div>
                    </header>

                    <div class="modal-body no-scrollbar modal-generic-body">
                        <div class="modal-generic-body-inner">
                            <div v-if="loading" class="modal-generic-loading">
                                <div class="dot-flashing"></div>
                            </div>
                            <div v-else class="modal-generic-form">
                                <div
                                    v-for="(field, index) in fieldsModalGeneric"
                                    :key="index"
                                    class="modal-field"
                                    :class="{ 'modal-field--wide': field.type === 5 }"
                                >
                                    <label class="modal-field-label" :for="`mg-field-${index}`">{{ field.title }}</label>

                                    <div v-if="field.type === 1" class="modal-field-control">
                                        <input
                                            :id="`mg-field-${index}`"
                                            v-model="formData[field.property]"
                                            type="text"
                                            class="form-control modal-generic-input"
                                            :placeholder="field.description"
                                        />
                                    </div>

                                    <div v-if="field.type === 2" class="modal-field-control">
                                        <input
                                            :id="`mg-field-${index}`"
                                            v-model="formData[field.property]"
                                            type="date"
                                            class="form-control modal-generic-input"
                                        />
                                    </div>

                                    <div v-if="field.type === 3 || field.type === 4" class="modal-field-control">
                                        <input
                                            :id="`mg-field-${index}`"
                                            v-model="formData[field.property]"
                                            type="number"
                                            :step="field.type === 4 ? '0.01' : '1'"
                                            class="form-control modal-generic-input"
                                            :placeholder="field.description"
                                        />
                                    </div>

                                    <div v-if="field.type === 5" class="modal-field-control">
                                        <textarea
                                            :id="`mg-field-${index}`"
                                            v-model="formData[field.property]"
                                            class="form-control modal-generic-input modal-generic-textarea"
                                            :placeholder="field.description"
                                            rows="6"
                                        />
                                    </div>

                                    <div v-if="field.type === 6" class="modal-field-control modal-field-check">
                                        <input
                                            :id="`mg-field-${index}`"
                                            v-model="formData[field.property]"
                                            type="checkbox"
                                            class="form-check-input modal-generic-check"
                                        />
                                    </div>

                                    <div v-if="field.type === 7" class="modal-field-control">
                                        <div class="modal-generic-select-wrap">
                                            <select
                                                :id="`mg-field-${index}`"
                                                v-model="formData[field.property]"
                                                class="form-control modal-generic-select"
                                            >
                                                <option value="">Selecione uma opção</option>
                                                <option v-for="option in field.options" :key="option.value" :value="option.value">
                                                    {{ option.value }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <footer class="modal-generic-footer">
                        <button type="button" class="btn modal-generic-btn modal-generic-btn--ghost" @click="closeModal">
                            Cancelar
                        </button>
                        <button type="button" class="btn modal-generic-btn modal-generic-btn--primary" @click="handleSave">
                            Enviar
                        </button>
                    </footer>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
    name: 'ModalGeneric',
    data() {
        return {
            formData: {},
            loading: false
        };
    },
    computed: {
        ...mapState(['isVisibleSideBarGenericModal', 'fieldsModalGeneric', 'currentCrew']),
        crewDescription() {
            const d = this.currentCrew?.description;
            if (!d || !String(d).trim()) return '';
            return String(d).trim();
        }
    },
    watch: {
        fieldsModalGeneric: {
            immediate: true,
            handler(fields) {
                if (!Array.isArray(fields)) return;
                const next = { ...this.formData };
                fields.forEach(field => {
                    if (next[field.property] !== undefined) return;
                    const v = field.value;
                    if (v !== undefined && v !== null && v !== '') {
                        next[field.property] = v;
                        return;
                    }
                    const d = field.default;
                    if (d !== undefined && d !== null && d !== '') {
                        next[field.property] = d;
                        return;
                    }
                    next[field.property] = field.type === 6 ? false : '';
                });
                this.formData = next;
            }
        }
    },
    methods: {
        ...mapActions(['storeIsVisibleSideBarGenericModal', 'storeCurrentRunIa']),
        handleSave() {
            this.loading = true;
            const payload = {
                id: 0,
                type_engine: 1,
                crew_id: this.currentCrew.id,
                request_type: 1,
                status: 0,
                parameters: this.fieldsModalGeneric.map(field => ({
                    type: 1,
                    property: field.property,
                    value: this.formData[field.property]
                }))
            };

            console.log(payload);
            this.storeCurrentRunIa({ currentRunIa: payload });
            this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: false });
            this.$router.push('/chat');
            this.loading = false;
        },
        closeModal() {
            this.storeIsVisibleSideBarGenericModal({ isVisibleSideBarGenericModal: false });
        }
    }
};
</script>

<style scoped lang="scss">
.modal-generic-backdrop {
    position: fixed;
    z-index: 1040;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(10, 11, 14, 0.72);
    backdrop-filter: blur(6px);
    transition: opacity 0.25s ease;
    opacity: 1;
    pointer-events: auto;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.25s ease;
}
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

/* Painel lateral: altura e coluna flex */
.modal-generic-dialog {
    margin: 0;
    max-width: min(440px, 100vw);
    height: 100%;
    min-height: 100%;
}

.modal-generic.modal-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 100vh;
    border: none;
    border-radius: 0;
    border-left: 1px solid rgba(255, 255, 255, 0.08);
    background: linear-gradient(180deg, #1c1d22 0%, #141518 100%);
    box-shadow: -12px 0 40px rgba(0, 0, 0, 0.45);
}

.modal-generic-head {
    flex-shrink: 0;
    padding: 0.65rem 1rem 1rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    background: rgba(0, 0, 0, 0.2);
}

.modal-generic-toolbar {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 0.75rem;
}

.modal-generic-toolbar-title {
    flex: 1;
    text-align: center;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #6b7280;
}

.modal-generic-icon-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    padding: 0;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    background: rgba(255, 255, 255, 0.04);
    color: #c8cdd8;
    cursor: pointer;
    transition: color 0.15s ease, border-color 0.15s ease, background 0.15s ease;
}
.modal-generic-icon-btn:hover {
    color: #fff;
    border-color: rgba(206, 255, 31, 0.35);
    background: rgba(206, 255, 31, 0.08);
}

.modal-generic-hero {
    padding-right: 0.25rem;
}

.modal-generic-title {
    margin: 0 0 0.35rem;
    font-size: clamp(1.15rem, 3.5vw, 1.4rem);
    font-weight: 700;
    color: #f2f3f5;
    line-height: 1.25;
    letter-spacing: -0.02em;
}

.modal-generic-desc {
    margin: 0;
    font-size: 13px;
    line-height: 1.5;
    color: #8b9199;
}

.modal-generic-body {
    flex: 1 1 auto;
    min-height: 0;
    overflow-y: auto;
    padding: 0;
}

.modal-generic-body-inner {
    padding: 1rem 1rem 0.5rem;
}

.modal-generic-form {
    display: flex;
    flex-direction: column;
    gap: 1.1rem;
}

.modal-field {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
}

.modal-field-label {
    font-size: 13px;
    font-weight: 600;
    color: #d1d5db;
    letter-spacing: 0.01em;
}

.modal-generic-input,
.modal-generic-select {
    width: 100%;
    padding: 0.65rem 0.85rem;
    font-size: 14px;
    line-height: 1.4;
    color: #f2f3f5;
    background: #25262c !important;
    border: 1px solid rgba(255, 255, 255, 0.1) !important;
    border-radius: 10px !important;
    box-shadow: none !important;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}
.modal-generic-input::placeholder {
    color: #6b7280;
}
.modal-generic-input:focus,
.modal-generic-select:focus {
    outline: none;
    border-color: rgba(206, 255, 31, 0.45) !important;
    box-shadow: 0 0 0 3px rgba(206, 255, 31, 0.12) !important;
}

.modal-generic-textarea {
    min-height: 120px;
    resize: vertical;
}

.modal-generic-select-wrap {
    position: relative;
}
.modal-generic-select {
    appearance: none;
    padding-right: 2.25rem;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none'%3E%3Cpath d='M6 9l6 6 6-6' stroke='%239ca3af' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 0.75rem center;
    cursor: pointer;
}
.modal-generic-select option {
    background: #1c1d22;
    color: #e5e7eb;
}

.modal-field-check {
    padding-top: 0.25rem;
}
.modal-generic-check {
    width: 1.15rem;
    height: 1.15rem;
    border-radius: 4px;
    cursor: pointer;
}

.modal-generic-loading {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 160px;
}

.dot-flashing {
    position: relative;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #29bbff;
    animation: dot-flashing 1s infinite linear alternate;
    animation-delay: 0.5s;
}

.dot-flashing::before,
.dot-flashing::after {
    content: '';
    display: inline-block;
    position: absolute;
    top: 0;
}

.dot-flashing::before {
    left: -15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #29bbff;
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 0s;
}

.dot-flashing::after {
    left: 15px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #29bbff;
    animation: dot-flashing 1s infinite alternate;
    animation-delay: 1s;
}

@keyframes dot-flashing {
    0% {
        background-color: #29bbff;
    }
    50%,
    100% {
        background-color: rgba(41, 187, 255, 0.2);
    }
}

.modal-generic-footer {
    flex-shrink: 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 0.65rem;
    padding: 0.85rem 1rem 1.1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(0, 0, 0, 0.35);
}

.modal-generic-btn {
    min-width: 6.5rem;
    padding: 0.55rem 1.15rem;
    font-size: 14px;
    font-weight: 600;
    border-radius: 10px;
    border: none;
    cursor: pointer;
    transition: transform 0.12s ease, opacity 0.12s ease;
}
.modal-generic-btn:active {
    transform: scale(0.98);
}

.modal-generic-btn--ghost {
    background: transparent;
    color: #c8cdd8;
    border: 1px solid rgba(255, 255, 255, 0.14);
}
.modal-generic-btn--ghost:hover {
    border-color: rgba(255, 255, 255, 0.28);
    color: #fff;
}

.modal-generic-btn--primary {
    background: rgba(206, 255, 31, 0.22);
    color: #dff565;
    border: 1px solid rgba(206, 255, 31, 0.4);
}
.modal-generic-btn--primary:hover {
    background: rgba(206, 255, 31, 0.32);
    border-color: rgba(206, 255, 31, 0.55);
}

.modal-body.no-scrollbar {
    scrollbar-width: thin;
    scrollbar-color: rgba(255, 255, 255, 0.15) transparent;
}
.modal-body.no-scrollbar::-webkit-scrollbar {
    width: 6px;
}
.modal-body.no-scrollbar::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.12);
    border-radius: 99px;
}
</style>
